var map = {
	"./y2020/I.mp3": 5560,
	"./y2020/akane.mp3": 5426,
	"./y2020/ha.mp3": 4215,
	"./y2020/haruka.mp3": 3294,
	"./y2020/myou.mp3": 7125,
	"./y2020/nagi.mp3": 9547,
	"./y2020/namari.mp3": 7825,
	"./y2020/soku.mp3": 5385,
	"./y2020/tomoe.mp3": 3506,
	"./y2020/torico.mp3": 1972,
	"./y2020/you.mp3": 4199,
	"./y2020/yuki.mp3": 7121,
	"./y2021/Kage-Sakasama.mp3": 9240,
	"./y2021/Kieteiku.mp3": 8348,
	"./y2021/Kondaku.mp3": 1909,
	"./y2021/Kyoei.mp3": 8072,
	"./y2021/Sakuran.mp3": 3676,
	"./y2021/Sen-Nuritubusu.mp3": 6296,
	"./y2021/bobaku.mp3": 7585,
	"./y2021/eisya.mp3": 722,
	"./y2021/kakera.mp3": 7513,
	"./y2021/koku.mp3": 2959,
	"./y2021/kowaku.mp3": 5914,
	"./y2021/kyokan.mp3": 1770,
	"./y2021/kyomei.mp3": 7021,
	"./y2021/kyosyu.mp3": 9126,
	"./y2021/paragram.mp3": 8410,
	"./y2021/toho.mp3": 1202,
	"./y2021/yuen.mp3": 9478,
	"./y2021/zankyo.mp3": 8785,
	"./y2022/imada-kurikaesu.mp3": 9713,
	"./y2022/konohi.mp3": 7463,
	"./y2022/kugi-hai.mp3": 3086,
	"./y2022/kyoei.mp3": 9954,
	"./y2022/tada-omou.mp3": 6472,
	"./y2022/ugokenai-ten.mp3": 9437,
	"./y2023/bokyaku.mp3": 6597,
	"./y2023/kiri-no-naka.mp3": 9938,
	"./y2023/rakka-hoko.mp3": 847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3996;